import { GetPrimeTradeDetailsData } from "@services/models/Prime/GetPrimeTradeDetailsModel";

const COMPLETED_EVENT_IDS = new Set(["4", "6"]);

export const isPrimeTradeCompleted = (
  data?: Pick<GetPrimeTradeDetailsData, "eventDetails"> | null,
): boolean => {
  if (!data) return false;

  return (
    data.eventDetails?.some((event) =>
      COMPLETED_EVENT_IDS.has(String(event.eventId)),
    ) ?? false
  );
};
